import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { FeatureFlags } from '~commonInfra/featureFlags/FeatureFlags';
import { MapDispatchToProps, MapStateToProps } from '~commonInfra/utils/ConnectUtils';
import { selectInlineBannerInfo } from '~src/bootstrap/redux/selectors/InlineBannerInfoSelector';
import { SessionSiteSelectors, SessionUserSelectors } from '~src/bootstrap/redux/selectors/SessionInfoSelectors';
import { siteUrlsSelector } from '~src/bootstrap/redux/selectors/SiteUrlsSelectors';
import { AppState } from '~src/bootstrap/redux/state/AppState';
import { addContentFavorite, removeContentFavorite } from '~src/favorites/actions/FavoritesActions';
import { renameContent } from '~src/spacesPlatform/actions/RenameContentAction';
import { selectSearchText } from '~src/spacesPlatform/selectors/ContentFilterSelectors';
import { selectAvailableActionsForEntity } from '~src/spacesPlatform/selectors/EntityActionsSelectors';
import { selectLayoutType } from '~src/spacesPlatform/selectors/LayoutTypeSelector';
import { NavLocationSelectors, selectPreviousUrl } from '~src/spacesPlatform/selectors/NavigationStateSelectors';
import { selectSpaceInfo } from '~src/spacesPlatform/selectors/SpaceInfoSelectors';
import { IViewInfo } from '~src/views/models/IViewInfo';

import { requestAvailableActionsForEntity } from '../../actions/AvailableActionsForEntityActions';
import { setLayoutType } from '../../actions/LayoutTypeAction';
import { displayBreadcrumbsForNavLocation } from './NavLocation';
import { PageHeader, PageHeaderDispatchProps, PageHeaderOwnProps, PageHeaderStateProps } from './PageHeader';

const mapStateToProps: MapStateToProps<PageHeaderStateProps> = (state: AppState): PageHeaderStateProps => {
  const spaceInfo = selectSpaceInfo(state);
  const inlineBannerInfo = selectInlineBannerInfo(state);
  const item = spaceInfo && spaceInfo.item as IViewInfo;
  const workbookId = item && item.workbook && item.workbook.id;

  return {
    isInVizViewerArea: NavLocationSelectors.inVizViewerArea(state),
    isInPredictiveModelEditor: NavLocationSelectors.inPredictiveModelEditor(state),
    isOnSiteStatusViz: NavLocationSelectors.inSiteStatusViz(state),
    isOnServerStatusViz: NavLocationSelectors.inServerStatusViz(state),
    isInServerArea: NavLocationSelectors.inServerArea(state),
    // TFSID 912777: we need to always know the page we are on in order to choose the page header
    // we can't use spaceInfo selectors because the spaceInfo is not always up to date, because some pages
    // do not update the SpaceInfo
    inSearchNavLocation: NavLocationSelectors.inSearchNavLocation(state),

    spaceInfo: spaceInfo,
    inlineBannerInfo: inlineBannerInfo,
    siteUrls: siteUrlsSelector(state),
    previousUrl: selectPreviousUrl(state),
    workbookActions: selectAvailableActionsForEntity(state, { id: workbookId, contentType: 'workbook' }),
    displayBreadCrumbs: displayBreadcrumbsForNavLocation(NavLocationSelectors.selectNavLocation(state)),
    layoutType: selectLayoutType(state),
    searchTerm: selectSearchText(state),
    isMetricDetail: NavLocationSelectors.isMetricDetail(state),
    isInlineBanner: SessionSiteSelectors.siteTypeName(state) === 'Trial' &&
                    SessionSiteSelectors.subscribeNowEnabled(state) &&
                    (SessionUserSelectors.siteRoleId(state) === 11 || SessionUserSelectors.siteRoleId(state) === 0) &&
                    (FeatureFlags.trialBannerDesignEnabled || SessionSiteSelectors.isInlineBannerEnabled(state))
  };
};

const mapDispatchToProps: MapDispatchToProps<PageHeaderDispatchProps> = (dispatch) => bindActionCreators({
  addContentFavorite: addContentFavorite,
  removeContentFavorite: removeContentFavorite,
  getWorkbookActions: requestAvailableActionsForEntity,
  setLayoutType: setLayoutType,
  renameContent: renameContent
}, dispatch);


export const ConnectedPageHeader: React.ComponentClass<PageHeaderOwnProps> =
  connect(mapStateToProps, mapDispatchToProps)(PageHeader);
